(function() {
    'use strict';

    angular.module('aprima-provider-api').factory('LoginInitializationService', [
        '$q',
        'LoginInitializationServiceTs',
        LoginInitializationService
    ]);

    function LoginInitializationService(
        $q,
        LoginInitializationServiceTs
    ) {
        return {
            initializeFromPrmLogin: initializeFromPrmLogin,
            initializeFromDesktopLogin: initializeFromDesktopLogin,
            preLogin: preLogin,
            finishPrmLogin: finishPrmLogin,
            updateVersionInfo: updateVersionInfo,
        };

        function initializeFromPrmLogin(userLoginInfo) {
            var promise = LoginInitializationServiceTs.initializeFromPrmLogin(userLoginInfo);
            return $q.when(promise);
        }

        function initializeFromDesktopLogin(vals) {
            var promise = LoginInitializationServiceTs.initializeFromDesktopLogin(vals);
            return $q.when(promise);
        }

        function preLogin(gatewayUrl, appServerUrl, clientId, username) {
            return LoginInitializationServiceTs.preLogin(gatewayUrl, appServerUrl, clientId, username);
        }

        function finishPrmLogin() {
            LoginInitializationServiceTs.finishPrmLogin();
        }

        function updateVersionInfo(userLoginInfo) {
            LoginInitializationServiceTs.updateVersionInfo(userLoginInfo);
        }
    }
})();